module.exports = __webpack_public_path__ + "static/media/defi-illustration.bdd82d93.svg";